import React from "react";
import { Drawer as DrawerPrimitive } from "vaul";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { DrawerOverlayProps } from "../types";

function DrawerOverlay({ className, ...props }: DrawerOverlayProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <DrawerPrimitive.Overlay
      data-slot="drawer-overlay"
      className={cn("fixed inset-0 z-50 bg-black/80", className, classes)}
      {...native}
    />
  );
}

DrawerOverlay.displayName = "Drawer.Overlay";

export default DrawerOverlay;
